<mat-card class="banner-card">
  <h2><mat-icon aria-hidden="true">campaign</mat-icon>{{ title }}</h2>
  <p>{{ message }}</p>
</mat-card>
